// Declare a websocket singleton to connect to port 8888

class Websocket {
    constructor() {
        //console.log("Connecting to: "+location.hostname+':'+window.SOCKET_PORT);
        this.socket = io.connect(location.hostname+':'+window.SOCKET_PORT, { autoConnect: true });
        this.onConnect.bind(this);
        this.onDisconnect.bind(this);
        this.onError.bind(this);
        this.init();
    }

    init() {
        this.socket.on('connect', this.onConnect);
        this.socket.on('disconnect', this.onDisconnect);
        this.socket.on('qpx-error', this.onError);
    }

    onConnect() {
        console.log('Client has connected to the server!');
    }

    onError(error) {
        console.log('Error: '+error);
        //display error message
        var modal = document.getElementById('error-box');
        var span = document.getElementsByClassName("close")[0];
        document.getElementById("gif-background").style.display = "none";
        modal.style.display = "block";
        span.onclick = function(){
            modal.style.display = "none";
        }

        window.onclick = function(event){
            if (event.target == modal){
                modal.style.display = "none";
            }
        }
        document.getElementsByClassName('modal-body')[0].innerHTML = error;
    }

    onDisconnect() {
        console.log('The client has disconnected!');
    }
}

export default Websocket



// WEBPACK FOOTER //
// ./Websocket.js